<template>
    <div class="row">
        <template v-if="!passwordChanged">
            <div class="col-xs-12 text-xs-center">
                <h3 class="modal__title">{{ $t('SET_NEW_PASSWORD') }}</h3>
                <br /><br />
                <p>
                    {{ $t('INSERT_PASSWORD_AND_REPEAT') }}
                </p>
                <br />

                <form novalidate>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-sm-offset-3 form-group mb-5">
                            <p v-if="formSubmitted && errors.any()" class="validate-danger">
                                <img src="./../../assets/images/icons/excl-red.svg" />
                                {{ $t('COMPLETE_FIELDS_CORRECTLY') }}
                            </p>
                            <input
                                name="password"
                                v-validate="{ required: true, regex: passwordRegex }"
                                v-model="password"
                                type="password"
                                :placeholder="$t('INSERT_NEW_PASSWORD')"
                                class="col-xs-12 mb-3 text-input -white-input-border input"
                                aria-required="true"
                            />
                            <input
                                name="passwordRepeat"
                                v-validate="{ required: true, regex: passwordRegex, confirmed: password }"
                                v-model="passwordRepeat"
                                :placeholder="$t('PASSWORD_CONFIRM')"
                                type="password"
                                class="col-xs-12 col-sm-6 text-input -white-input-border input"
                                aria-required="true"
                            />
                        </div>
                    </div>
                    <div class="text-center">
                        <button
                            class="app-btn app-btn--small app-btn-primary-reverse --no-border --no-bg"
                            @click.prevent="closeWindow"
                        >
                            {{ $t('CANCEL') }}
                        </button>
                        <button
                            class="app-btn app-btn--big app-btn-primary"
                            type="submit"
                            @click.prevent="validateBeforeSubmit"
                        >
                            {{ $t('SAVE') }}
                        </button>
                    </div>
                </form>
            </div>
        </template>
        <template v-else>
            <div class="col-xs-12 text-xs-center">
                <h3 class="modal__title" style="font-size: 26px">{{ $t('PASSWORD_CORRECTLY_CHANGED') }}</h3>
                <br /><br />
                <div class="text-center">
                    <button class="app-btn app-btn--big app-btn-primary" @click="closeWindow">{{ $t('CLOSE') }}</button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { config } from '../../main';

export default {
    data() {
        return {
            passwordRegex: config.passwordRegex,
            password: '',
            passwordRepeat: '',
            formSubmitted: false,
            passwordChanged: false,
        };
    },
    methods: {
        validateBeforeSubmit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.$http.patch('/user/api/profile/user/password', { password: this.password }).then(() => {
                        this.formSubmitted = false;
                        this.passwordChanged = true;
                    });
                }
                this.formSubmitted = true;
            });
        },
        closeWindow() {
            this.password = '';
            this.passwordRepeat = '';
            this.$emit('close');
            this.passwordChanged = false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// set-new-password.vue?2351910a